import React from "react";
import Routes from "./Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { motion } from "framer-motion";
import ScrollToTop from "./ScrollTop";
import { AuthProvider } from "./contexts/AuthContext";
import "./assets/css/responsive.css";
import "./styles/shadcn.css";
import "./styles/tailwind.css";
import "./styles/font.css";
import "./styles/index.css";

function App() {
  return (
    <AuthProvider>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Router>
          <ScrollToTop />
          <Routes />
        </Router>
      </motion.div>
    </AuthProvider>
  );
}

export default App;
